import React, { useState, useEffect, useRef } from "react";
import urls from "../../api/urls";
import API from "../../api";
import Heading from "../../components/Heading";
import { message, Table, Input, Spin, Tabs, Tooltip } from "antd";
import Smcs_Loader from "../../assests/images/loader-new.gif";
import search_icon from "../../assests/images/search-icon.svg";
import { getPremiseId } from "../../utils/worker";
import SeriesCard from "./SeriesCard";
import { capitaliseWithHyphen } from "../../utils";

function ViewSeries() {
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [tableData, setTableData] = useState([]);
  const [pageNum, setPageNum] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearchVal] = useState("");
  const premiseId = getPremiseId();

  const { GET_CP_ASSIGN_SERIES } = urls;

  useEffect(() => {
    getTableData(pageNum, pageSize);
  }, []);

  const getTableData = async (pageNum, pageSize, search) => {
    setLoading(true);
    let url = `${GET_CP_ASSIGN_SERIES}?pageNum=${pageNum}&pageSize=${pageSize}`;

    if (search) {
      url += `&search=${search}`;
    }
    let response = await API.Api(url).getCustomHeader({
      premiseId: premiseId.split("Bearer ")[1],
    });
    if (response?.status) {
      setLoading(false);
      setTableData(response?.response?.data);
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network Error");
    }
  };

  const column1 = [
    {
      title: "Series Type",
      dataIndex: "seriesType",
      key: "seriesType",
      width: 60,
      render: (text) => <span>{text || "N/A"}</span>,
    },
    {
      title: "HUB Name",
      dataIndex: "hubName",
      key: "hubName",
      width: 80,
      ellipsis: true,
      render: (text) => <span>{text || "N/A"}</span>,
    },
    {
      title: "CP Name",
      dataIndex: "cpName",
      key: "cpName",
      width: 120,
      // ellipsis: true,
      render: (text) => formatText(capitaliseWithHyphen(text), 40),
    },
    {
      title: "Branch Name",
      dataIndex: "branchName",
      key: "branchName",
      width: 120,
      // ellipsis: true,
      render: (text) => formatText(capitaliseWithHyphen(text), 40),
    },
  ];

  const column2 = [
    ...column1,
    {
      title: "Client Name",
      dataIndex: "clientName",
      key: "clientName",
      width: 90,
      ellipsis: true,
      render: (text) => <span>{text || "N/A"}</span>,
    },
    {
      title: "From",
      dataIndex: "seriesFrom",
      key: "seriesFrom",
      width: 90,
      render: (text) => <span className="fw-500">{text || "N/A"}</span>,
    },
    {
      title: "To",
      dataIndex: "seriesTo",
      key: "seriesTo",
      width: 90,
      render: (text) => <span className="fw-500">{text || "N/A"}</span>,
    },
    {
      title: "Assigned Date",
      dataIndex: "createdDate",
      key: "createdDate",
      width: 80,
      render: (text) => <span>{text?.split(" ")?.[0] || "N/A"}</span>,
    },
  ];

  const formatText = (name, charLength) => {
    if (!name) return "N/A";
    return (
      <>
        {name?.length > charLength ? (
          <Tooltip title={name} placement="bottom">
            {name?.length > charLength
              ? `${name?.substring(0, charLength)}..`
              : name}
          </Tooltip>
        ) : (
          name
        )}
      </>
    );
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const debounceTimeout = useRef(null);

  const handlePageChange = (pagination) => {
    getTableData(pagination.current - 1, pagination.pageSize);
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
  };

  const onSearch = (e) => {
    const currValue = e.target.value;
    setSearchVal(currValue);
    setPageNum(0);
    setPageSize(pageSize);
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(async () => {
      getTableData(0, 20, currValue);
    }, 500);
  };

  return (
    <div className="p-1">
      <Heading title={"Search Series"} />
      <div className="master-main-container lead-client-approval-list p-1">
        <Spin spinning={loading}>
          <div className="align-center">
            <Input
              placeholder="Search Series"
              bordered
              maxLength={16}
              style={{
                borderRadius: "5px",
                height: "30px",
                fontSize: "12px",
                marginRight: "10px",
                width: "200px",
              }}
              onChange={onSearch}
              suffix={<img src={search_icon} />}
              onKeyPress={(e) => {
                if (/[^0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </div>

          {search?.length > 0 ? (
            <SeriesCard
              data={tableData?.barcodeList?.[0]}
              assigned={tableData?.assigned}
            />
          ) : (
            <Tabs defaultActiveKey="1">
              <Tabs.TabPane tab="Assigned Series" key="1">
                <Table
                  headerClassName="header"
                  className="table-head-sticky mt-05 "
                  loading={{
                    indicator: (
                      <img
                        src={Smcs_Loader}
                        style={{ height: "100px", width: "100px" }}
                      />
                    ),
                    spinning: loading,
                  }}
                  columns={tableData?.assigned ? column2 : column1}
                  dataSource={tableData?.barcodeList || []}
                  onChange={handlePageChange}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    total: tableData?.count,
                    pageSizeOptions: ["10", "20", "50", "100"],
                    showSizeChanger: true,
                    itemRender: itemRender,
                  }}
                />
              </Tabs.TabPane>
            </Tabs>
          )}
        </Spin>
      </div>
    </div>
  );
}

export default ViewSeries;
